import _ from 'lodash';

export default {
  computed: {
    isFilled() {
      return this.sectionResources.length > 0;
    },
  },
  methods: {
    updateIsEditingResource(resource, isEdited) {
      console.log(`updating ${resource.coreResource.name} to ${isEdited}`);
      const path = this.isResourceEnvSection(resource) ? 'activeTemplate.data.env' : 'activeTemplate.data.divisions[0]';
      // eslint-disable-next-line
      const { sectionResources } = _.get(this.$store.state, path);
      const sectionResourceIndex = sectionResources.findIndex((sr) => sr.id === resource.id);
      sectionResources[sectionResourceIndex].isEdited = isEdited;
      this.$store.commit('updateState', {
        path: `${path}.sectionResources`,
        value: sectionResources,
      });
    },
    isAssumpitonValid(value) {
      const antiPattern = /[^0-9.;]+/;
      const isValid = value && value.length ? !antiPattern.test(value) : true;
      const validationErrorMessage = this.translate('ui_assumptions_validation_error');
      return isValid || validationErrorMessage;
    },
    onSwitchClick(module) {
      // eslint-disable-next-line
      const moduleIndex = this.$store.state.activeTemplate.data.modules.findIndex((moduleInState) => moduleInState.id === module.id);
      this.$store.commit('updateState', {
        path: `activeTemplate.data.modules[${moduleIndex}].isEnabled`,
        value: !module.isEnabled,
      });

      /*
      const searchForSection = module.mappedToSection ? module.mappedToSection : module;
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === searchForSection.id);

      // delay to let the switch animate
      this.$store.commit('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isEnabled`,
        value: !searchForSection.isEnabled,
      });

       */

      // let UI update
      setTimeout(() => {
        // scroll to if enabled
        if (module.isEnabled) {
          this.scrollToSection(module.id, true);

          // don't show dialogs for wc and ia by default
          console.log(module.id);
          if (module.id !== 'module_wc' && module.id !== 'module_ip') {
            this.$store.commit('updateState', {
              path: 'activeTemplate.isNavigatorVisible',
              value: module.id,
            });
          }

          // show section settings if no resources
          const searchForSection = module.templateSectionCfg ? module.templateSectionCfg : module;
          // eslint-disable-next-line
          const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === searchForSection.id);
          if (searchForSection.sectionResources && searchForSection.sectionResources.length === 0) {
            this.$store.dispatch('updateState', {
              path: `activeTemplate.data.sections[${sectionIndex}].isEditingSettings`,
              value: true,
            });
            this.$store.dispatch('updateState', {
              path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
              value: true,
            });
          }
        }
        // trigger preview update
        this.$store.dispatch('saveRemoteTemplate');
      }, 100);
    },
    scrollToSection(sectionId, delay) {
      // eslint-disable-next-line
      const sectionsEnabled = this.$store.state.activeTemplate.data.sections.filter((section) => section.isEnabled);
      // eslint-disable-next-line
      const sectionIndex = sectionsEnabled.findIndex((sectionInState) => sectionInState.id === sectionId);
      // return;
      const scroller = () => {
        this.onScrollDisabled = true;
        const that = this;
        const target = document.getElementById(sectionId);
        if (!target) {
          return;
        }

        // console.log(top);

        this.onScrollDisabled = false;
        const scrollDistance = 100; // sectionId === 'section_timeline' ? 200 : 100;
        const elementY = window.scrollY + (target.getBoundingClientRect().top - scrollDistance);// (top ? 50 : 150); // target.getBoundingClientRect().top - (top ? 50 : 150);

        const duration = 500;

        const startingY = window.scrollY;
        const diff = elementY - startingY;
        let start;

        // animate scrolling
        window.requestAnimationFrame(function step(timestamp) {
          if (!start) start = timestamp;
          // Elapsed milliseconds since start of scrolling.
          const time = timestamp - start;
          // Get percent of completion in range [0, 1].
          const percent = Math.min(time / duration, 1);

          window.scrollTo(0, startingY + diff * percent);

          // Proceed with animation as long as we wanted it to.
          if (time < duration) {
            window.requestAnimationFrame(step);
          } else {
            that.onScrollDisabled = false;
          }
        });
      };
      if (delay) {
        // eslint-disable-next-line
        setTimeout(() => {
          scroller();
        }, 300);
      } else {
        scroller();
      }
    },
    getModuleById(moduleId, getters = this.$store.getters) {
      let result;
      getters.previewedModules.forEach((module) => {
        if (module.id === moduleId) {
          result = module;
        }
      });
      // console.log(`... result of looking for module ${moduleId}: ${result}`);
      return result;
    },
    getSectionById(sectionId, getters = this.$store.getters) {
      let result;
      getters.sections.forEach((section) => {
        if (section.sections) {
          section.sections.forEach((sect) => {
            if (sect.id === sectionId) {
              result = sect;
            }
          });
        }
        if (section.id === sectionId) {
          result = section;
        }
      });
      // console.log(`... result of looking for section ${sectionId}: ${result}`);
      return result;
    },
    getSectionByRel(rel) {
      let result;
      this.$store.getters.sections.forEach((section) => {
        if (section.sections) {
          section.sections.forEach((sect) => {
            if (sect.coreResourceTypes && sect.coreResourceTypes.includes(rel)) {
              result = sect;
            }
          });
        }
        if (section.coreResourceTypes && section.coreResourceTypes.includes(rel)) {
          result = section;
        }
      });
      return result;
    },
    getSectionResourcesByRel(rel) {
      const envRels = ['currency', 'taxproperty', 'deprgroup'];
      const division = envRels.includes(rel)
        ? this.$store.state.activeTemplate.data.env
        : this.$store.state.activeTemplate.data.divisions[0];

      return division.sectionResources.filter((sr) => sr.coreResource.rel === rel);
    },
    localizeDate(dateObj) {
      const locale = this.$store.state.activeTemplate.language === 'en' ? 'en-US' : 'ru-RU';
      // eslint-disable-next-line
      const result = dateObj.toLocaleDateString(locale);
      return result;
    },
    editModuleOrSection(moduleOrSection) {
      const { sections } = this.$store.state.activeTemplate.data;
      let sectionIndex;
      if (moduleOrSection.id.includes('module')) {
        // it's a module
        if (moduleOrSection.id === 'module_cover' || moduleOrSection.id === 'module_wc' || moduleOrSection.id === 'module_ip') {
          // cover preview
          const value = this.$store.state.activeTemplate.isNavigatorVisible === moduleOrSection.id ? null : moduleOrSection.id;
          this.$store.dispatch('updateState', {
            path: 'activeTemplate.isNavigatorVisible',
            value,
          });
        }
        if (moduleOrSection.templateSectionCfg) {
          sectionIndex = sections.findIndex((sect) => sect.id === moduleOrSection.templateSectionCfg.id);
        }
      } else {
        // it's a section
        sectionIndex = sections.findIndex((sect) => sect.id === moduleOrSection.id);
      }

      if (sectionIndex) {
        sections[sectionIndex].isEditingSettings = !sections[sectionIndex].isEditingSettings;
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.sections',
          value: sections,
        });
      }
      // if (moduleOrSection.id === 'module_wc' || moduleOrSection.id === 'module_ip') {
      //   const value = this.$store.state.activeTemplate.isNavigatorVisible === moduleOrSection.id ? null : moduleOrSection.id;
      //   this.$store.dispatch('updateState', {
      //     path: 'activeTemplate.isNavigatorVisible',
      //     value,
      //   });
      // }
    },
    toggleSectionEditingSettings(section) {
      if (typeof section === 'string') {
        // eslint-disable-next-line
        section = this.getSectionById(section);
      }
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === section.id);
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isEditingSettings`,
        value: !this.$store.state.activeTemplate.data.sections[sectionIndex].isEditingSettings,
      });
      // if (section.autoSelectFirstInput) {
      //   this.selectFirstInput(section.id);
      // }
    },

    // selectFirsInput(sectionId, timeout = 0) {
    //   setTimeout(() => {
    //     const firstInput = document.querySelector(`#${sectionId} input[type="text"]`);
    //     if (firstInput) {
    //       firstInput.focus();
    //       firstInput.select();
    //     }
    //   }, timeout);
    // },
    generateResourcesData(section) {
      const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
      sectionResources.forEach((sectionResource) => {
        if (section.sectionResources.find((sectResource) => sectResource.id === sectionResource.id)) {
          this.generateSampleData(sectionResource);
        }
      });
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.divisions[0].sectionResources',
        value: sectionResources,
      });
      // save template
      this.$store.dispatch('saveRemoteTemplate');
    },
    clearResourcesData(section) {
      const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
      sectionResources.forEach((sectionResource) => {
        if (section.sectionResources.find((sectResource) => sectResource.id === sectionResource.id)) {
          this.clearResourceData(sectionResource);
        }
      });
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.divisions[0].sectionResources',
        value: sectionResources,
      });
      // save template
      this.$store.dispatch('saveRemoteTemplate');
    },
    deleteResources(event, resources) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      let isEnvResource = false;
      const firstResource = resources[0];
      let sectionId = this.getSectionByRel(firstResource.coreResource.rel).id;

      switch (firstResource.coreResource.rel) {
        case 'currency':
          sectionId = 'section_currency';
          isEnvResource = true;
          break;
        case 'taxincome':
        case 'taxproperty':
          sectionId = 'section_taxes';
          isEnvResource = true;
          break;
        case 'deprgroup':
          sectionId = 'section_depreciation';
          isEnvResource = true;
          break;
        case 'service':
          sectionId = 'section_sales';
          break;
        case 'sga':
          sectionId = 'section_sga';
          break;
        case 'fixedasset':
          sectionId = 'section_fixedassets';
          break;
        case 'equity':
        case 'loan':
          sectionId = 'section_financing';
          break;
        default:
        //
      }

      // eslint-disable-next-line
      let sectionResources = isEnvResource ? this.$store.state.activeTemplate.data.env.sectionResources : this.$store.state.activeTemplate.data.divisions[0].sectionResources;
      const resourcesIds = resources.map((resource) => resource.id);
      sectionResources = sectionResources.filter((resource) => !resourcesIds.includes(resource.id));

      // const sectionResourceIndex = sectionResources.findIndex((sr) => sr.id === resource.id);
      // sectionResources.splice(sectionResourceIndex, 1);

      const pathToCommit = isEnvResource ? 'activeTemplate.data.env.sectionResources' : 'activeTemplate.data.divisions[0].sectionResources';

      this.$store.commit('updateState', {
        path: pathToCommit,
        value: sectionResources,
      });

      // delete coreResource
      let { coreResources } = this.$store.state.activeTemplate.data;
      const coreResourcesIds = resources.map((resource) => resource.coreResource.id);

      coreResources = coreResources.filter((coreResource) => !coreResourcesIds.includes(coreResource.id));
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.coreResources',
        value: coreResources,
      });

      // show section settings if no resources
      setTimeout(() => {
        const section = this.$store.state.activeTemplate.data.sections.find((sect) => sect.id === sectionId);
        if (section.sectionResources && section.sectionResources.length === 0) {
          // eslint-disable-next-line
          const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === sectionId);
          this.$store.dispatch('updateState', {
            path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
            value: true,
          });
        }
      }, 100);

      // save template
      this.$store.dispatch('saveRemoteTemplate');
    },
    moveSectionResource(resource) {
      const targetRel = resource.coreResource.rel === 'sga' ? 'cos' : 'sga';
      // update rel
      const { coreResources } = this.$store.state.activeTemplate.data;
      const coreResourceIndex = coreResources.findIndex((cr) => cr.id === resource.coreResource.id);
      coreResources[coreResourceIndex].rel = targetRel;
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.coreResources',
        value: coreResources,
      });
      // make sure formula allows the new rel too
      const { formula } = resource.flows[0];
      if (!formula.allowedRels.includes(targetRel)) {
        // debugger;
        const { formulas } = this.$store.state.activeTemplate.data;
        const formulaIndex = formulas.findIndex((f) => f.id === formula.id);
        formulas[formulaIndex].allowedRels.push(targetRel);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.formulas',
          value: formulas,
        });
      }

      // save template
      this.$store.dispatch('saveRemoteTemplate');
    },
    // remove below and use the one above
    deleteResource(event, resource) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      let isEnvResource = false;
      let sectionId = this.getSectionByRel(resource.coreResource.rel).id;

      switch (resource.coreResource.rel) {
        case 'currency':
          sectionId = 'section_currency';
          isEnvResource = true;
          break;
        case 'taxincome':
        case 'taxproperty':
          sectionId = 'section_taxes';
          isEnvResource = true;
          break;
        case 'deprgroup':
          sectionId = 'section_depreciation';
          isEnvResource = true;
          break;
        case 'service':
          sectionId = 'section_sales';
          break;
        case 'sga':
          sectionId = 'section_sga';
          break;
        case 'fixedasset':
          sectionId = 'section_fixedassets';
          break;
        case 'equity':
        case 'loan':
          sectionId = 'section_financing';
          break;
        default:
          //
      }

      // eslint-disable-next-line
      const sectionResources = isEnvResource ? this.$store.state.activeTemplate.data.env.sectionResources : this.$store.state.activeTemplate.data.divisions[0].sectionResources;

      const sectionResourceIndex = sectionResources.findIndex((sr) => sr.id === resource.id);
      sectionResources.splice(sectionResourceIndex, 1);

      const pathToCommit = isEnvResource ? 'activeTemplate.data.env.sectionResources' : 'activeTemplate.data.divisions[0].sectionResources';

      this.$store.commit('updateState', {
        path: pathToCommit,
        value: sectionResources,
      });

      // delete coreResource
      let { coreResources } = this.$store.state.activeTemplate.data;
      coreResources = coreResources.filter((cr) => cr.id !== resource.coreResource.id);
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.coreResources',
        value: coreResources,
      });

      // show section settings if no resources
      setTimeout(() => {
        const section = this.$store.state.activeTemplate.data.sections.find((sect) => sect.id === sectionId);
        if (section.sectionResources && section.sectionResources.length === 0) {
          // eslint-disable-next-line
          const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === sectionId);
          const { sections } = this.$store.state.activeTemplate.data;
          // sections[sectionIndex].isEditingSettings = true;
          this.$store.dispatch('updateState', {
            path: 'activeTemplate.data.sections',
            value: sections,
          });
        }
      }, 100);

      // save template
      this.$store.dispatch('saveRemoteTemplate');
    },
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    uuidv4nodash() {
      return 'xxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    translate(content, language = 'en', state = this.$store.state) {
      if (!content) {
        return '';
      }

      let result = content;
      if (state.languages) {
        if (state.user.settings.language) {
          // eslint-disable-next-line
          language = state.user.settings.language;
        } else if (state.activeTemplate && state.activeTemplate.language) {
          // eslint-disable-next-line
          language = state.activeTemplate.language;
        }

        // eslint-disable-next-line
        const translated = state.languages[content] ? state.languages[content][language] : false;
        if (typeof translated !== 'undefined' && translated !== false) {
          result = translated;
        } else {
          // don't translate currency
          // eslint-disable-next-line
          if (state.activeTemplate && state.activeTemplate.data) {
            const defaultCurrency = state.activeTemplate.data.coreResources.find((cr) => cr.isDefault);
            if (defaultCurrency.name !== content) {
              console.warn(`translation not found for ${content}`);
            }
          }
        }
      }
      return result;
    },
    showBuildDialog() {
      if (this.$store.state.activeTemplate.isBuildDialogShown) {
        return;
      }
      this.$store.commit('updateState', {
        path: 'activeTemplate.isBuildDialogShown',
        value: true,
      });
      setTimeout(() => {
        this.$store.commit('updateState', {
          path: 'dialogs.endOfWizardDialogVisible',
          value: true,
        });
        setTimeout(() => {
          const dialogContainer = document.querySelector('.v-dialog__content--active');
          const dialogZIndex = Number(dialogContainer.style.zIndex);
          dialogContainer.style.zIndex = dialogZIndex + 1;
          // eslint-disable-next-line
          confetti({ particleCount: 150, spread: 300, zIndex: 201, origin: { x: 0.5, y: 0.5 }, startVelocity: 30, ticks: 70, });
          // confetti({ particleCount: 30, spread: 70, zIndex: 201, origin: { x: 0.5, y: 0.65 }, startVelocity: 30, ticks: 80, });
        }, 0);
      }, 200);
    },
    // revealNextSection() {
    //   // eslint-disable-next-line
    //   const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
    //   let nextSectionIndex = sectionIndex + 1;
    //
    //   let nextSection = this.$store.state.activeTemplate.data.sections[nextSectionIndex];
    //   if (!nextSection || nextSection.isInitialized) {
    //     nextSectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((section) => !section.isInitialized);
    //     if (nextSectionIndex !== -1) {
    //       nextSection = this.$store.state.activeTemplate.data.sections[nextSectionIndex];
    //       // likely the first sections - general, timeline, environment
    //       // show them all
    //       if (nextSection.id === 'section_general') {
    //         this.$store.commit('updateState', {
    //           path: 'activeTemplate.data.sections[0].isVisible',
    //           value: true,
    //         });
    //         this.$store.commit('updateState', {
    //           path: 'activeTemplate.data.sections[1].isVisible',
    //           value: true,
    //         });
    //         this.$store.commit('updateState', {
    //           path: 'activeTemplate.data.sections[2].isVisible',
    //           value: true,
    //         });
    //       }
    //     } else {
    //       //
    //     }
    //   }
    //
    //   if (nextSection && nextSection.isEnabled && !nextSection.isInitialized) {
    //     if (!nextSection.isVisible) {
    //       setTimeout(() => {
    //         const div = document.getElementById(nextSection.id);
    //         div.style.opacity = 0;
    //       }, 100);
    //     }
    //
    //     setTimeout(() => {
    //       const div = document.getElementById(nextSection.id);
    //       div.style.opacity = 1;
    //     }, 200);
    //
    //     // show add resource dialog
    //     if (!this.$store.state.activeTemplate.isWizardEnabled) {
    //       if (nextSection.sectionResources) {
    //         this.$store.commit('updateState', {
    //           path: `activeTemplate.data.sections[${nextSectionIndex}].isAddingResource`,
    //           value: true,
    //         });
    //       } else {
    //         this.$store.commit('updateState', {
    //           path: `activeTemplate.data.sections[${nextSectionIndex}].isEditingSettings`,
    //           value: true,
    //         });
    //       }
    //     }
    //
    //     // scroll to next section
    //     console.log(`... scrolling to ${nextSection.id}`);
    //     this.scrollToSection(nextSection.id, 50);
    //
    //     if (nextSection.autoSelectFirstInput) {
    //       // don't scroll
    //       this.selectFirstInput(nextSection.id, 200);
    //     }
    //   } else {
    //     //
    //   }
    //   return nextSectionIndex;
    // },
    saveSection(section) {
      // transition
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === section.id);

      // this should be section id specific
      if (section.id === 'section_general') {
        this.$store.commit('updatePageTitle', this.$store.state.activeTemplate.name);
      }

      // set flags for the current section
      if (this.section.isAddingResource) {
        this.$store.commit('updateState', {
          path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
          value: false,
        });
      }
      // if (this.section.isEditingSettings) {
      //   this.$store.commit('updateState', {
      //     path: `activeTemplate.data.sections[${sectionIndex}].isEditingSettings`,
      //     value: false,
      //   });
      // }
      // const isSectionJustInitalized = !this.section.isInitialized;
      if (!this.section.isInitialized) {
        this.$store.dispatch('updateState', {
          path: `activeTemplate.data.sections[${sectionIndex}].isInitialized`,
          value: true,
        });
      }

      // scroll to next section
      // if (!this.$store.state.activeTemplate.isWizardEnabled) {
      //   const nextSectionIndex = this.revealNextSection();
      //   if (nextSectionIndex === -1) {
      //     this.showBuildDialog();
      //   }
      // }


      // if (isSectionJustInitalized) {
      //   const nextSectionIndex = this.revealNextSection();
      //   if (nextSectionIndex === -1) {
      //     this.showBuildDialog();
      //   }
      // }

      // save user too
      this.$store.dispatch('saveRemoteTemplate');
    },
    toggleModule(module) {
      // TODO - rename to toggleModules
      const moduleIndex = this.$store.state.activeTemplate.data.modules.findIndex((m) => m.id === module.id);
      const { isEnabled } = this.$store.state.activeTemplate.data.modules[moduleIndex];
      // allow for special effects if disabling
      if (isEnabled) {
        // hiding module
        this.$store.commit('updateState', {
          path: `activeTemplate.data.modules[${moduleIndex}].isDisabling`,
          value: true,
        });
        setTimeout(() => {
          this.$store.commit('updateState', {
            path: `activeTemplate.data.modules[${moduleIndex}].isDisabling`,
            value: false,
          });
        }, 5000);

        // hide navigator if was visible for the hiding module
        if (this.$store.state.activeTemplate.isNavigatorVisible === module.id) {
          this.$store.commit('updateState', {
            path: 'activeTemplate.isNavigatorVisible',
            value: null,
          });
        }
        // switch off isEditingSettings
        const section = module.templateSectionCfg && this.getSectionById(module.templateSectionCfg.id);
        if (section && section.isEditingSettings) {
          const { sections } = this.$store.state.activeTemplate.data;
          const sectionIndex = sections.findIndex((sect) => sect.id === section.id);
          sections[sectionIndex].isEditingSettings = false;
          this.$store.commit('updateState', {
            path: 'activeTemplate.data.sections',
            value: sections,
          });
        }
      }
      this.$store.commit('updateState', {
        path: `activeTemplate.data.modules[${moduleIndex}].isEnabled`,
        value: !isEnabled,
      });
    },
    skipSection(sectionId) {
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((section) => section.id === sectionId);
      this.$store.commit('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isEnabled`,
        value: false,
      });
      // TODO - find next enabled section
      // const newActiveSectionIndex = sectionIndex + 1;
      // if (this.$store.state.activeTemplate.data.sections[newActiveSectionIndex]) {
      //   this.$store.commit('updateState', {
      //     path: `activeTemplate.data.sections[${newActiveSectionIndex}].isActive`,
      //     value: true,
      //   });
      //   // save it
      //   this.$store.dispatch('saveTemplate');
      // }
    },
    selectFirstInput(param) {
      const that = this;
      let inputToSelect;
      if (typeof param === 'object') {
        inputToSelect = param;
      }
      setTimeout(() => {
        if (!inputToSelect) {
          // eslint-disable-next-line
          const currentDialog = that.$refs.dialog || that.$refs.dialogSimple;
          if (currentDialog) {
            // editing resource
            const currentDialogElement = currentDialog;
            // scroll dialog to the top
            currentDialogElement.scrollTop = 0;
            inputToSelect = currentDialogElement.querySelector('input[type="text"]');
          } else {
            // editing section
            const sectionId = param;
            inputToSelect = document.querySelector(`#${sectionId} input[type="text"]`);
          }
        }
        // don't autofocus if on small screen
        if (document.documentElement.clientWidth > 600 && inputToSelect) {
          inputToSelect.focus();
          inputToSelect.select();
        }
      }, 100);
    },
    getFormulas(resource) {
      let formulas = [];
      if (!resource) {
        formulas = this.$store.state.activeTemplate.data.formulas;
      } else {
        // eslint-disable-next-line
        formulas = this.$store.state.activeTemplate.data.formulas.filter(f => {
          if (!f.allowedRels) {
            console.log('formula is broken', f);
          }
          return f.allowedRels && f.allowedRels.includes(resource.coreResource.rel);
        });
      }
      return formulas;
    },
    createNewSectionResource(section, resourceRel, formulaId) {
      const envRels = ['currency', 'taxproperty', 'deprgroup'];
      // const section = envRels.includes(resourceRel) ? this.$store.state.activeTemplate.data.env
      // : this.$store.state.activeTemplate.data.divisions[0];

      // eslint-disable-next-line
      const rel = resourceRel || (section.coreResourceTypes.length > 1 ? null : section.coreResourceTypes[0]);

      const sect = envRels.includes(rel)
        ? this.$store.state.activeTemplate.data.env
        : this.$store.state.activeTemplate.data.divisions[0];

      // eslint-disable-next-line
      const nextResourceIndex = sect.sectionResources.filter((r) => r.coreResource.rel === rel).length + 1;
      const addResourceLabel = rel === 'equity' || rel === 'loan' ? rel : section.addResourceLabel;
      const nameTranslated = `${this.translate(addResourceLabel)} ${nextResourceIndex}`;
      const name = nameTranslated.charAt(0).toUpperCase() + nameTranslated.slice(1);
      const coreResource = {
        id: this.uuidv4nodash(),
        name,
        rel,
        units: '',
        value: '',
        isDefault: false,
        consists_of: [],
      };

      let defaultFormula;
      if (formulaId) {
        // eslint-disable-next-line
        defaultFormula = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === formulaId);
      } else if (rel) {
        // eslint-disable-next-line
        defaultFormula = this.$store.state.activeTemplate.data.formulas.find((f) => f.allowedRels.includes(rel));
      }

      if (!defaultFormula) {
        // eslint-disable-next-line
        defaultFormula = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === 'amount');
      }

      // const variable = defaultFormula.variables[0];
      // eslint-disable-next-line
      const defaultCurrency = this.$store.state.activeTemplate.data.coreResources.find(cr => cr.isDefault);
      const flows = [{
        formula: defaultFormula,
        hist: [
          {
            id: '22881_1579736704254',
            lookupId: false,
            scenarios: [
              {
                id: '22881_1579736704255',
                name: 'Base scenario',
                data: '0',
                units: defaultCurrency,
              },
            ],
            variable: 'amount1',
            _allowEdit: true,
          },
        ],
        fcst: (() => defaultFormula.variables.map((variabl) => ({
          id: '22881_1579736704252',
          lookupId: false,
          scenarios: [
            {
              id: '22881_1579736704253',
              name: 'Base scenario',
              data: '0',
              units: variabl.isCurrency ? defaultCurrency : variabl.units,
            },
          ],
          variable: variabl.id,
          _allowEdit: true,
        })))(),
        optionChecked: false,
      }];

      // TODO: refactor autodrawdown and by default autorepayment at resource creation
      if (section.id === 'section_financing') {
        flows[0].id = 'incCash';
        // add finance repayment
        const autorepaymentloanFormula = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === 'autorepaymentloan');
        flows.push({
          id: 'expCash',
          formula: defaultFormula.id === 'autodrawdownloan' ? autorepaymentloanFormula : defaultFormula,
          hist: [
            {
              id: '22881_1579736704254',
              lookupId: false,
              scenarios: [
                {
                  id: '22881_1579736704255',
                  name: 'Base scenario',
                  data: '0',
                  units: defaultCurrency,
                },
              ],
              variable: 'amount1',
              _allowEdit: true,
            },
          ],
          fcst: [
            {
              id: '22881_1579736704252',
              lookupId: false,
              scenarios: [
                {
                  id: '22881_1579736704253',
                  name: 'Base scenario',
                  data: '0',
                  units: defaultCurrency,
                },
              ],
              variable: 'amount1',
              _allowEdit: true,
            },
          ],
          optionChecked: false,
        });
      } else {
        flows[0].id = 'incBook';
      }

      const cfg = {
        id: this.uuidv4nodash(),
        coreResource,
        flows,
        isEdited: false,
        isSelected: false,
      };

      // add otherAssumptions
      if (resourceRel !== 'taxproperty') {
        cfg.otherAssumptions = {
          accountsReceivablePeriod: {
            value: null,
            lookupId: '',
            useDefault: true,
          },
          inventoryPeriod: {
            value: null,
            lookupId: '',
            useDefault: true,
          },
          accountsPayablePeriod: {
            value: null,
            lookupId: '',
            useDefault: true,
          },
          interestmargin: {
            name: 'input_resource_options_interestmargin',
            value: null,
            units: 'percent',
          },
          dividend: {
            type: 'percent',
            name: 'input_resource_options_dividend',
            value: null,
            units: 'percent',
          },
          deprgroup: {
            lookupId: null,
            lookupCollection: 'deprgroup',
          },
          taxproperty: {
            lookupId: null,
            lookupCollection: 'taxproperty',
          },
          commitment: {
            type: 'percent',
            name: 'input_resource_options_commitmentpercent',
            value: null,
            units: 'percent',
          },
        };
      }

      return cfg;
    },
    clearResourceData(sectionResource) {
      sectionResource.flows[0].fcst.forEach((fcst) => {
        // eslint-disable-next-line
        fcst.scenarios[0].data = '0';
      });
    },
    generateSampleData(sectionResource) {
      sectionResource.flows[0].fcst.forEach((fcst) => {
        const { cFcstColCount } = this.$store.state.activeTemplate.layout;
        const dataArray = [];
        const startingValue = Math.floor(Math.random() * 100);
        const growth = 0.05;
        for (let j = 0; j < cFcstColCount; j++) {
          dataArray.push(Math.floor(startingValue * (1 + growth * j)));
        }
        // eslint-disable-next-line
        fcst.scenarios[0].data = dataArray.join(';');
      });
    },
    saveSelectedSuggestedResources(cfg) {
      const { suggestionsForSection, sectionId } = cfg;
      const section = this.$store.state.activeTemplate.data.sections.find((sect) => sect.id === sectionId);
      for (let i = 0; i < suggestionsForSection.length; i++) {
        const selectedResource = suggestionsForSection[i];
        const { formula } = selectedResource;
        if (formula) {
          // check if the formula is already there in formulas
          const formulaExists = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === formula.id);
          if (!formulaExists) {
            const { language } = this.$store.state.activeTemplate;
            formula.name = formula.name[language];
            formula.variables.forEach((variable) => {
              // eslint-disable-next-line
              variable.name = variable.name[language];
              if (typeof variable.units === 'object') {
                // eslint-disable-next-line
                variable.units = variable.units[language];
              }
              return variable;
            });
            // save formula in the template formulas
            const { formulas } = this.$store.state.activeTemplate.data;
            formulas.push(formula);
            this.$store.commit('updateState', {
              path: 'activeTemplate.data.formulas',
              value: formulas,
            });
          }
        }

        const { rel } = selectedResource;
        // eslint-disable-next-line
        const sectionResource = this.createNewSectionResource(section, rel, formula && formula.id);
        // add sample data
        if (this.$store.state.isGeneratingSampleData) {
          this.generateSampleData(sectionResource);
        }

        // if fixed asset, set depreciation
        if (rel === 'fixedasset') {
          sectionResource.otherAssumptions = {
            deprgroup: {
              lookupId: '05',
              lookupCollection: 'deprgroup',
            },
            taxproperty: {
              lookupId: null,
              lookupCollection: 'taxproperty',
            },
          };
        }

        sectionResource.coreResource.name = `${suggestionsForSection[i].name}`;
        // save new coreResource
        const { coreResources } = this.$store.state.activeTemplate.data;
        coreResources.push(sectionResource.coreResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });

        // TODO - need this?
        const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
        sectionResources.push(sectionResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.divisions[0].sectionResources',
          value: sectionResources,
        });

        const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sect) => sect.id === sectionId);
        this.$store.dispatch('updateState', {
          path: `activeTemplate.data.sections[${sectionIndex}].isInitialized`,
          value: true,
        });
      }
    },
    cacheScrollPosition() {
      const { scrollY } = window;
      this.$store.commit('updateState', {
        path: 'dialogScrollYPosition',
        value: scrollY,
      });
    },
    scrollToDialog(elementId) {
      // scroll to the beginning of dialog, if not fully visible
      // let Vue display it first
      setTimeout(() => {
        const dialogElement = document.querySelector(`#${elementId} .section-settings-container__form`);
        if (dialogElement) {
          const extendsBeyondFold = dialogElement.getBoundingClientRect().top + dialogElement.scrollHeight - window.innerHeight;
          console.log(`extendsBeyondFold: ${extendsBeyondFold}`);
          if (extendsBeyondFold > 0) {
            window.scroll({
              top: document.documentElement.scrollTop + extendsBeyondFold + 100,
              behavior: 'smooth',
            });
          }
        }
      }, 100);
    },
    addSectionResource(section, shouldScrollToTrigger) {
      // const findSection = (sections, searchingForSection) => {
      //   let foundSection = false;
      //   // eslint-disable-next-line
      //   sections.forEach((sectionInState) => {
      //     if (sectionInState.id === searchingForSection.id) {
      //       foundSection = sectionInState;
      //     }
      //     if (sectionInState.sections && sectionInState.sections.length) {
      //       foundSection = findSection(sectionInState.sections, searchingForSection);
      //     }
      //   });
      //   return foundSection;
      // };
      // eslint-disable-next-line
      section.isAddingResource = true;
      // const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.sections',
        value: this.$store.state.activeTemplate.data.sections,
      });
      this.scrollToDialog(section.id);
      if (shouldScrollToTrigger) {
        this.cacheScrollPosition();
      }
    },
    onAssumptionsChange(flowIndex, assumptionIndex, value) {
      // eslint-disable-next-line
      this.dialogConfig.resource.flows[flowIndex].fcst[assumptionIndex].scenarios[0].data = value;
    },
    onFormulaChange() {
      // get default currency
      // eslint-disable-next-line
      const defaultCurrency = this.$store.state.activeTemplate.data.coreResources.find(cr => cr.isDefault);

      // update resource fcst values
      const formulaVariables = this.dialogConfig.resource.flows[0].formula.variables;
      const fcstVariables = this.dialogConfig.resource.flows[0].fcst;

      if (formulaVariables.length < fcstVariables.length) {
        fcstVariables.splice(formulaVariables.length);
      } else if (formulaVariables.length > fcstVariables.length) {
        // eslint-disable-next-line
        for (let i = fcstVariables.length; i < formulaVariables.length; i++) {
          fcstVariables.push({
            id: '22881_1579736704252',
            lookupId: false,
            scenarios: [
              {
                id: '22881_1579736704253',
                name: 'Base scenario',
                data: null,
                units: formulaVariables[i].isCurrency ? defaultCurrency
                  : this.translate(formulaVariables[i].units),
              },
            ],
            variable: formulaVariables[i],
            _allowEdit: true,
          });
        }
      }

      // check to switch isCurrency if needed
      fcstVariables.forEach((fcst, index) => {
        if (!formulaVariables[index].isCurrency && typeof fcst.scenarios[0].units === 'object') {
          // eslint-disable-next-line
          fcst.scenarios[0].units = this.translate(formulaVariables[index].units);
        }
        if (formulaVariables[index].isCurrency && typeof fcst.scenarios[0].units !== 'object') {
          // eslint-disable-next-line
          fcst.scenarios[0].units = defaultCurrency;
        }
      });
    },
    isResourceEnvSection(resource) {
      const envRels = ['currency', 'taxproperty', 'taxincome', 'deprgroup'];
      return envRels.includes(resource.coreResource.rel);
    },
    saveResource(dCfg) {
      const envRels = ['currency', 'taxproperty', 'taxincome', 'deprgroup'];
      const path = envRels.includes(dCfg.resource.coreResource.rel)
        ? 'activeTemplate.data.env'
        : 'activeTemplate.data.divisions[0]';

      // eslint-disable-next-line
      const { sectionResources } = _.get(this.$store.state, path);

      // eslint-disable-next-line
      const exists = sectionResources.find((resource) => {
        return resource.id === dCfg.resource.id;
      });

      if (exists) {
        // existing
        // eslint-disable-next-line
        const sectionResourceIndex = sectionResources.findIndex((sr) => sr.id === dCfg.resource.id);

        // eslint-disable-next-line
        dCfg.resource.isEdited = false;

        sectionResources.splice(sectionResourceIndex, 1, dCfg.resource);

        this.$store.commit('updateState', {
          path: `${path}.sectionResources`,
          value: sectionResources,
        });

        // update coreResource name
        const { coreResources } = this.$store.state.activeTemplate.data;
        const coreResource = coreResources.find((cr) => cr.id
          === dCfg.resource.coreResource.id);
        coreResource.name = dCfg.resource.coreResource.name;
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });
      } else {
        // new
        // save new coreResource
        const { coreResources } = this.$store.state.activeTemplate.data;
        coreResources.push(dCfg.resource.coreResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });

        // if property tax, add lookupId to the parent resource
        const isBigResourceDialogVisible = this.$store.state.dialogs.editResourceDialogVisible;
        if (isBigResourceDialogVisible) {
          // eslint-disable-next-line
          this.dialogConfig.resource.otherAssumptions.taxproperty.lookupId = dCfg.resource.id;
        }

        // decide the position in list
        if (dCfg.position) {
          // for now can only add after
          const afterResourceIndex = sectionResources.findIndex((resource) => resource.id === dCfg.position.afterResource.id);
          sectionResources.splice(afterResourceIndex, 0, dCfg.resource);
        } else {
          // append
          sectionResources.push(dCfg.resource);
        }
      }

      this.$store.commit('updateState', {
        path: `${path}.sectionResources`,
        value: sectionResources,
      });
    },
    addResource(event, section, sectionComponent, resourceRel, simpleDialog, formulaId) {
      if (event) {
        event.preventDefault();
      }

      // reset dialog data
      this.dialogAssumptions = [];

      const newSectionResource = this.createNewSectionResource(section, resourceRel, formulaId);
      const addResourceLabel = `${this.translate(section.addResourceLabel)}`;

      const formulas = this.getFormulas(newSectionResource);
      // eslint-disable-next-line
      const units = newSectionResource.flows[0].fcst.map((fcst) => {
        return fcst.scenarios[0].units;
      });

      const title = `${this.translate('ui_add_btn')} ${addResourceLabel}`;

      const config = {
        title,
        formulas,
        resource: newSectionResource,
        section,
        sectionComponent,
        units,
        initialStep: section.id === 'section_financing' ? 1 : 2, // resourceRel ? 2 : 1,
        showSuggestions: false, // TODO - make this work
      };

      // eslint-disable-next-line
      // this.dialogFormula = formulas[0];

      if (simpleDialog) {
        this.dialogSimpleConfig = config;
        this.$store.commit('updateState', {
          path: 'dialogs.editResourceDialogSimpleVisible',
          value: true,
        });
      }
      // else {
      //   this.dialogConfig = config;
      //   this.$store.commit('updateState', {
      //     path: 'dialogs.resourceAddDialogVisible',
      //     value: true,
      //   });
      // }
      this.selectFirstInput();
    },
    getScreenshotSrc(templateId, screenshotFileName) {
      return `/api/template/screenshot?templateId=${templateId}&filename=${screenshotFileName}`;
    },
  },
};
